import React from "react";
import imagen from "../../generalComponents/images/logoBPW.png";

export const TimeManagementInitial = () => {
	return (
		<div>
			<div className="containerIcon">
				<h2> ADMINISTRACIÓN DE TIEMPOS </h2>
				<br />
				<br />
				<br />
				<img src={imagen} />
			</div>
		</div>
	);
};
